<template>
  <div class="jr-label">
    <div class="left">
      <h2 class="title-text" v-if="title">{{title}}</h2>
      <slot name="title" />
    </div>
    <div class="right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.jr-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    justify-content: center;
    align-items: center;
    .title-text {
      position: relative;
      padding-left: 10px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #272728;
      &:before {
        content: '';
        display: block;
        position: absolute;
        width: 4px;
        height: 16px;
        top: calc((100% - 16px) / 2);
        left: 0;
        background-color: $color-primary;
        border-radius: 1px;
      }
    }
  }
}
</style>
